import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import { PiBuildingsFill } from "react-icons/pi";
import { LuPlus } from "react-icons/lu";
import { TfiLayoutGrid2Alt } from "react-icons/tfi";
import LogoImg from "../../assests/zelo-logo-new.png";
import "../../../src/TextFamily.css";
import "./DeshBoard.css";
import SidebarNavigation from "./SidebarNavigation";
import Header from "../../HomeLayout/Header/Header";
import MyCompanyList from "./BankDetails/MyCompanyList";
import { Outlet } from "react-router";
import VirticalNavigation from "./VirticalNavigation";
import SideBar from "../../HomeLayout/Sidebar/SideBar";

function DeshBoard(props) {
  return (
    <div>
      <div className="">
        {/* <img src={LogoImg} style={{ width: 114 }} /> */}
        <Header socket={props?.socket} />
      </div>
      <div className="deshboard-full-section d-flex flex-wrap">
        <div className="virtical-navigation-box py-4 px-3">
          <VirticalNavigation />
          {/* <SideBar/> */}
        </div>
        <div className="deshboard-inner flex-wrap d-flex">
          <SidebarNavigation progressRefreshKey={props?.progressRefreshKey} />
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default DeshBoard;
